import { styled } from '@mui/material/styles';
import { Modal } from '@mui/material';

export const AdminModal = styled(Modal)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
